const microwaveDetailedRateCard = {
  key: "microwave",
  title: "Microwave Detailed Rate Card",
  note:
    "Indicative microwave pricing. Magnetron, fuse, PCB, and heating-side failures often need inspection before exact pricing.",
  sections: [
    {
      title: "Inspection",
      items: [
        { name: "Microwave inspection", price: "₹249 visit" },
      ],
    },
    {
      title: "Repair Support",
      items: [
        { name: "Power / startup issue", price: "₹349 onwards" },
        { name: "Heating issue support", price: "₹399 onwards" },
        { name: "Turntable / plate rotation issue", price: "₹299 onwards" },
      ],
    },
  ],
};

export default microwaveDetailedRateCard;